var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#5D6B72",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.03124 6.52H6.81859V17.08H5.03124V6.52ZM7.71226 6.52H8.60594V17.08H7.71226V6.52ZM9.49961 6.52H12.1806V17.08H9.49961V6.52ZM13.0743 6.52H13.968V17.08H13.0743V6.52ZM15.7553 6.52H17.5427V17.08H15.7553V6.52ZM18.4364 6.52H19.33V17.08H18.4364V6.52ZM3.24389 4.76V8.28H1.45654V4.76C1.45654 3.78798 2.25677 3 3.24389 3H6.81859V4.76H3.24389ZM21.1174 3C22.1045 3 22.9047 3.78798 22.9047 4.76V8.28H21.1174V4.76H17.5427V3H21.1174ZM3.24389 15.32V18.84H6.81859V20.6H3.24389C2.25677 20.6 1.45654 19.812 1.45654 18.84V15.32H3.24389ZM21.1174 18.84V15.32H22.9047V18.84C22.9047 19.812 22.1045 20.6 21.1174 20.6H17.5427V18.84H21.1174Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScan);
export default __webpack_public_path__ + "static/media/scan.11921962.svg";
export { ForwardRef as ReactComponent };